import React from "react";
import { useEffect, useState } from "react";
import imageGeneratorService from "../services/imageGeneratorService";
import NavBar from "../components/NavBar";
import Container from "react-bootstrap/esm/Container";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/Button";
import "../css/generalcard.css";

function Uninstall() {
	const [imageResult, setImageResult] = useState({
		imageUrl: "",
		createdBy: "",
		linkToProfile: "",
	});
	const onImageSuccess = (response) => {
		const randomIndex = Math.floor(Math.random() * response.results.length);

		const randomImage = response.results[randomIndex];

		const imageUrl = randomImage.urls.full;

		setImageResult((prevState) => {
			let ps = { ...prevState };
			ps.imageUrl = imageUrl;
			ps.createdBy = randomImage.user.name;
			ps.linkToProfile = randomImage.user.links.html;
			return ps;
		});
	};

	const onImageFailed = (error) => {
		console.log(error);
	};

	const handleSubmit = (event) => {
		event.preventDefault();

		const googleStoreUrl = `https://support.google.com/chrome_webstore/answer/2664769`;

		//redirect
		window.location.href = googleStoreUrl;
	};

	useEffect(() => {
		imageGeneratorService
			.getBackGroundImage()
			.then(onImageSuccess)
			.catch(onImageFailed);
	}, []);

	return (
		<>
			<div
				style={{
					backgroundImage: `url(${imageResult.imageUrl})`,
					backgroundSize: "cover",
					backgroundRepeat: "no-repeat",
					height: "100vh",
				}}
			>
				<NavBar></NavBar>
				<Container className="h-25"></Container>
				<Container className="px-5">
					<Row>
						<Card className="h-100 bg-black opacity-75">
							<Card.Body>
								<Card.Title className="d-flex justify-content-around">
									<h1 className="border-bottom">Uninstall</h1>
								</Card.Title>
								<Card.Text className="d-flex justify-content-around">
									<p>
										To uninstall please click the button. We hope to see you
										again.
									</p>
								</Card.Text>
								<Card.Text className="d-flex justify-content-around">
									<Button onClick={handleSubmit} size="lg">
										Click here to uninstall.
									</Button>
								</Card.Text>

								<Card.Text className="d-flex justify-content-around ">
									<p>
										<a href="mailto:loyalstorageservices@gmail.com">loyalstorageservices@gmail.com</a>
									</p>
								</Card.Text>
							</Card.Body>
						</Card>
					</Row>
				</Container>
				<a
					href={imageResult.linkToProfile}
					style={{
						position: "absolute",
						bottom: "10px",
						left: "10px",
						color: "white",
						textDecoration: "underline",
					}}
				>
					Credit to: {imageResult.createdBy}
				</a>
			</div>
		</>
	);
}

export default Uninstall;
